import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CoachPage from './CoachPage';
import CoacheePage from './CoacheePage';
import BroadcasterPage from './BroadcasterPage';
import ErrorPage from './ErrorPage';

function AppRouter() {
  const [searchParams] = useSearchParams();
  const userType = searchParams.get('userType');

  // Route based on userType parameter
  switch (userType) {
    case 'coach':
      return <CoachPage />;
    case 'coachee':
      return <CoacheePage />;
    case 'broadcaster':
      return <BroadcasterPage />;
    default:
      return <ErrorPage userType={userType} />;
  }
}

export default AppRouter;
